
import React, { useState, useEffect, useRef, useCallback } from "react";
import {
    TextField,
    Grid,
    InputLabel,
    FormControl,
    Select,
    MenuItem,
    FormControlLabel,
    Checkbox,
    TextareaAutosize,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    Typography,
    Box,
    TableRow,
    Paper,
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
} from "@mui/material";
import ActionButtonGroup from "../../../Common/CommonButtons/ActionButtonGroup";
import NavigationButtons from "../../../Common/CommonButtons/NavigationButtons";
import Pagination from "../../../Common/UtilityCommon/Pagination";
import { useNavigate, useLocation } from "react-router-dom";
// import './RackLinkrailwaystation.css';
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AddButton from "../../../Common/Buttons/AddButton";
import EditButton from "../../../Common/Buttons/EditButton";
import DeleteButton from "../../../Common/Buttons/DeleteButton";
import OpenButton from "../../../Common/Buttons/OpenButton";
// import SystemHelpMasterItemWise from "../../../Helper/SystemmasterHelpForItemWise";
import SystemHelpMaster from "../../../Helper/SystemmasterHelp";
import UserAuditInfo from "../../../Common/UserAuditInfo/UserAuditInfo";
import SaveUpdateSpinner from "../../../Common/Spinners/SaveUpdateSpinner";
import DetailAddButtom from "../../../Common/Buttons/DetailAddButton";
import DetailCloseButton from "../../../Common/Buttons/DetailCloseButton";
import DetailUpdateButton from "../../../Common/Buttons/DetailUpdateButton";
import Swal from "sweetalert2";


const API_URL = process.env.REACT_APP_API;

var newMillid = "";
var newRailwaystationid = "";
var newMillname = "";
var newStationname = "";
var newId = "";
var toStationCode = "";
var Item_Code = "";
var Item_Name = "";
var effdate = "";
var marketcess = "";

const headerCellStyle = {
    fontWeight: "bold",
    backgroundColor: "#3f51b5",
    color: "white",
    padding: "6px",
    textAlign: "center",
    "&:hover": {
        backgroundColor: "#303f9f",
        cursor: "pointer",
    },
};

const ItemWiseCess = () => {


    const companyCode = sessionStorage.getItem("Company_Code");
    const YearCode = sessionStorage.getItem("Year_Code");
    const username = sessionStorage.getItem("username");
    const Post_Date = sessionStorage.getItem("Post_Date")
    const User_Id = sessionStorage.getItem("User_ID");

    const [isLoading, setIsLoading] = useState(false);
    const [updateButtonClicked, setUpdateButtonClicked] = useState(false);
    const [saveButtonClicked, setSaveButtonClicked] = useState(false);
    const [addOneButtonEnabled, setAddOneButtonEnabled] = useState(false);
    const [saveButtonEnabled, setSaveButtonEnabled] = useState(true);
    const [cancelButtonEnabled, setCancelButtonEnabled] = useState(true);
    const [editButtonEnabled, setEditButtonEnabled] = useState(false);
    const [deleteButtonEnabled, setDeleteButtonEnabled] = useState(false);
    const [backButtonEnabled, setBackButtonEnabled] = useState(true);
    const [isEditMode, setIsEditMode] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [highlightedButton, setHighlightedButton] = useState(null);
    const [cancelButtonClicked, setCancelButtonClicked] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [millId, setMillId] = useState("");
    const [millName, setMillName] = useState("");
    const [stationId, setstationId] = useState("");
    const [stationName, setstationName] = useState("");
    const [tableData, setTableData] = useState([])

    const [itemwiseTableData, setItemwiseTableData] = useState([]);
    const [users, setUsers] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [popupMode, setPopupMode] = useState("add");
    const [selectedUser, setSelectedUser] = useState({});
    const [deleteMode, setDeleteMode] = useState(false);
    const [itemCode, setItemCode] = useState("");
    const [item_Name, setItemName] = useState("");
    const [godowncode, setgodowncode] = useState("");
    const [godown_name, setgodown_name] = useState("");
    const [brand_code, setBrandCode] = useState("");
    const [brand_name, setBrandName] = useState("");
    const [itemCodeAccoid, setItemCodeAccoid] = useState("");
    const [perPage, setPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [isAddingRow, setIsAddingRow] = useState(false);


    const addButtonRef = useRef(null);
    const firstInputRef = useRef(null);

    //     const [amountInWords, setAmountInWords] = useState('');

    //SET focus to first input feild
    const setFocusToFirstField = () => {
        if (firstInputRef.current) {
            firstInputRef.current.focus();
        }
    };

    const navigate = useNavigate();

    //In utility page record doubleClicked that recod show for edit functionality
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const navigatedRecord = searchParams.get("navigatedRecord");
    const permissions = location.state?.permissionsData;
    const selectedRecord = location.state?.selectedRecord;


    const initialFormData = {
        Item_Code: "",
        Eff_Date: new Date().toISOString().split("T")[0],
        Market_Cess: 0.00,
        Dekrekh: 0.00,
        Hamali_on: "B",
        Hamali_rate: 0.00,
        Tolai_rate: 0.00,
        Tolad_on: "Q",
        Levi_rate: 0.00,
        Container: 0.00,
        Company_Code: companyCode,
        Year_Code: YearCode,
        ic: 0,
        Created_By: "",
        Modified_By: "",
        HamaliSale_rate: 0.00,
        TolaiSale_rate: 0.00,
        // Created_Date:new Date().toISOString().split("T")[0],
        // Modified_Date: new Date().toISOString().split("T")[0],
    };

    const [formData, setFormData] = useState(initialFormData);

    // Handle change for all inputs
    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevState) => {
            const updatedFormData = { ...prevState, [name]: value };
            return updatedFormData;
        });
    };

    const handleAddOne = () => {
        setAddOneButtonEnabled(false);
        setSaveButtonEnabled(true);
        setCancelButtonEnabled(true);
        setEditButtonEnabled(false);
        setDeleteButtonEnabled(false);
        setIsEditing(true);
        setFormData(initialFormData);
        setItemwiseTableData([])
        setItemCode([])
        setTimeout(() => {
            firstInputRef.current?.focus();
        }, 0);
    };


    const handleSaveOrUpdate = async () => {

        setIsEditing(true);
        setIsLoading(true);

        const validateNewRows = async () => {
            for (let row of itemwiseTableData) {
                // Only check rows that were recently added (not updated or normal)
                if (row.rowaction === 'add') {
                    // Prefer System_Code (converted to int), fallback to formData or itemCode
                    const itemCodeToCheck = parseInt(row?.System_Code) || formData.Item_Code || itemCode;
                    const effDate = row?.Eff_Date;

                    // Check if date is older than today's date
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);   // normalize

                    const eff = new Date(effDate);
                    eff.setHours(0, 0, 0, 0);     // normalize

                    if (eff < today) {
                        Swal.fire({
                            icon: "warning",
                            title: "Invalid Date",
                            text: `Date ${effDate} cannot be less than today's date.`,
                            confirmButtonColor: "#d33",
                        });
                        setIsLoading(false);
                        return false;
                    }


                    // Call your async checkMatchStatus function
                    const matchStatus = await checkMatchStatus(effDate, companyCode, YearCode, itemCodeToCheck);

                    if (matchStatus === 1) {
                        Swal.fire({
                            icon: "warning",
                            title: "Invalid Date / Date is used Again With Same Item Code",
                            text: `Item Code ${itemCodeToCheck} with Date ${effDate} already exists.`,
                            confirmButtonColor: "#d33",
                        });
                        setIsLoading(false);
                        return false;  // Return false to indicate validation failed
                    }
                }
            }

            return true; // All new rows validated successfully
        };

        const proceed = await validateNewRows();
        if (!proceed) {
            // Stop the operation because validation failed
            return;
        }



        const requestData = {
            headData: itemwiseTableData.map((row) => {
                const isExisting = !row?.Id;

                return {
                    Id: row?.Id,
                    Item_Code: parseInt(row?.System_Code) || formData.Item_Code || itemCode,
                    Eff_Date: row?.Eff_Date || new Date().toISOString().split("T")[0],
                    Market_Cess: parseFloat(row?.Market_Cess || 0.00),
                    Dekrekh: parseFloat(row?.Dekrekh) || 0,
                    Hamali_on: row?.Hamali_on || "B",
                    Hamali_rate: parseFloat(row?.Hamali_rate) || 0,
                    HamaliSale_rate: parseFloat(row?.HamaliSale_rate) || 0,
                    TolaiSale_rate: parseFloat(row?.TolaiSale_rate) || 0,
                    Tolai_rate: parseFloat(row?.Tolai_rate) || 0,
                    Tolad_on: row?.Tolad_on || "Q",
                    Levi_rate: parseFloat(row?.Levi_rate) || 0,
                    Container: parseFloat(row?.Container) || 0,
                    Company_Code: parseInt(companyCode),
                    Year_Code: parseInt(YearCode),
                    Created_By: username || !isExisting ? username : undefined,
                    Modified_By: username,
                    ic: parseInt(row?.systemid) || formData.ic || 0,
                    rowaction: row.rowaction
                };
            })
        };
        try {
            if (isEditMode) {
                const updateApiUrl = `${API_URL}/update_ItemWiseCess?Id=${newId}&Company_Code=${companyCode}`;
                console.log("newId", newId)
                const response = await axios.put(updateApiUrl, requestData);

                // unlockRecord();
                Swal.fire({
                    title: "Success!",
                    text: "Record updated successfully!",
                    icon: "success",
                    confirmButtonText: "OK",
                });
            } else {
                const response = await axios.post(
                    `${API_URL}/insert_ItemWiseCess`,
                    requestData
                );
                Swal.fire({
                    title: "Success!",
                    text: "Record saved successfully!",
                    icon: "success",
                    confirmButtonText: "OK",
                });
            }
            setIsEditMode(false);
            setAddOneButtonEnabled(true);
            setEditButtonEnabled(true);
            setDeleteButtonEnabled(true);
            setBackButtonEnabled(true);
            setSaveButtonEnabled(false);
            setCancelButtonEnabled(false);
            setUpdateButtonClicked(true);
            setIsEditing(false);

            // setTimeout(() => {
            //     window.location.reload();
            // }, 1000);
            // navigate(`/item_wise_cess?navigatedRecord=${formData.Item_Code}`);
        } catch (error) {
            console.error("Error during API call:", error);
            toast.error("Error occurred while saving data");
        } finally {
            setIsEditing(false);
            setIsLoading(false);
        }
    };


    const handleBack = () => {
        navigate("/item_wise_cess_utility");
    };


    const checkMatchStatus = async (Eff_Date, company_code, year_code, Item_Code) => {
        try {
            const { data } = await axios.get(
                `${process.env.REACT_APP_API}/get_match_status_forDate`,
                {
                    params: {
                        Eff_Date: Eff_Date,
                        Company_Code: company_code,
                        Year_Code: year_code,
                        Item_Code: Item_Code
                    },
                }
            );
            return data.match_status;
        } catch (error) {
            toast.error("Error checking GST State Code match.");
            console.error("Couldn't able to match GST State Code:", error);
            return error;
        }
    };

    const handleTableDataFromApi = useCallback((dataFromApi) => {
        if (dataFromApi?.Selected_SystemMaster_data) {
            // Replace or append conditionally depending on your use case
            setItemwiseTableData((prev) => [...prev, dataFromApi.Selected_SystemMaster_data]);
        }
    }, []);



    // Helper function
    const formatToInputDate = (dateStr) => {
        if (!dateStr) return "";
        const date = new Date(dateStr);
        return isNaN(date) ? "" : date.toISOString().split("T")[0]; // "YYYY-MM-DD"
    };


    const handleCancel = async () => {
        setItemwiseTableData([]);
        setFormData({});
        try {
            const response = await fetch(
                `${API_URL}/get-ItemWise-lastRecord?Company_Code=${companyCode}&Year_Code=${YearCode}`
            );

            if (response.ok) {
                const data = await response.json();

                const lastItemwiseArray = data.last_ItemWise_data || [];
                const ItemCode = data.Item_Code;

                setItemCode(ItemCode);

                const formattedRows = lastItemwiseArray.map((row) => ({
                    ...row,
                    id: row?.Id,
                    Item_Code: ItemCode,
                    rowaction: 'Normal',
                    Eff_Date: formatToInputDate(row.Eff_Date),
                    Market_Cess: parseFloat(row?.Market_Cess || 0.00),
                    // MarkaPerc: parseFloat(formData.Market_Cess || row.Market_Cess || 0.00),
                }));

                setItemwiseTableData(formattedRows);


                if (formattedRows.length > 0) {
                    setItemwiseTableData(formattedRows);
                    setFormData({
                        ...formattedRows[0],
                    });
                }
            } else {
                console.error(
                    "Failed to fetch first item-wise data:",
                    response.status,
                    response.statusText
                );
            }
        } catch (error) {
            console.error("Error during API call:", error);
        }
        setIsEditing(false);
        setIsEditMode(false);
        setAddOneButtonEnabled(true);
        setEditButtonEnabled(true);
        setDeleteButtonEnabled(true);
        setBackButtonEnabled(true);
        setSaveButtonEnabled(false);
        setCancelButtonEnabled(false);
        setCancelButtonClicked(true);
    };


    const handleEdit = async () => {
        // if (!formData?.Doc_No) {
        //     console.error(
        //         "❌ Cannot edit: formData.Id is missing or invalid",
        //         formData
        //     );
        //     Swal.fire({
        //         icon: "error",
        //         title: "Invalid Record",
        //         text: "The selected record is missing an ID.",
        //     });
        //     return;
        // }

        // console.log("✅ Sending Id:", formData.Id); // should not be undefined or empty

        axios
            .get(
                `${API_URL}/get-AwakAdvanceSelectedRecordByItemCode?Item_Code=${formData.Item_Code || itemCode}&Company_Code=${companyCode}&Year_Code=${YearCode}`
            )
            .then((response) => {
                const data = response.data;
                // const isLockedNew = data.last_head_data.LockedRecord;
                // const isLockedByUserNew = data.last_head_data.LockedUser;

                // if (isLockedNew) {
                //   Swal.fire({
                //     icon: "warning",
                //     title: "Record Locked",
                //     text: `This record is locked by ${isLockedByUserNew}`,
                //     confirmButtonColor: "#d33",
                //   });
                //   return
                // }
                // else {
                //   lockRecord();
                // }

                const lastItemwiseArray = data.selected_Record_data || [];
                const ItemCode = data.Item_Code;

                setItemCode(ItemCode);

                const formattedRows = lastItemwiseArray.map((row) => ({
                    ...row,
                    id: row.Id,
                    Item_Code: ItemCode,
                    rowaction: 'Normal',
                    Eff_Date: formatToInputDate(row.Eff_Date),
                    Market_Cess: parseFloat(row?.Market_Cess || 0.00),
                    // MarkaPerc: parseFloat(formData.Market_Cess || row.Market_Cess || 0.00),

                }));

                setItemwiseTableData(formattedRows);


                if (formattedRows.length > 0) {
                    setItemwiseTableData(formattedRows);
                    setFormData({
                        ...formattedRows[0],
                    });
                }
                setIsEditMode(true);
                setAddOneButtonEnabled(false);
                setSaveButtonEnabled(true);
                setCancelButtonEnabled(true);
                setEditButtonEnabled(false);
                setDeleteButtonEnabled(false);
                setBackButtonEnabled(true);
                setIsEditing(true);
            })
            .catch((error) => {
                // window.alert("This record is already deleted! Showing the previous record.");
            });
    };

    useEffect(() => {
        if (selectedRecord) {
            handlerecordDoubleClicked();
        } else if (
            navigatedRecord &&
            !isNaN(navigatedRecord) &&
            parseInt(navigatedRecord) > 0
        ) {
            handleNavigateRecord();
        } else {
            handleAddOne();
        }
    }, [selectedRecord, navigatedRecord]);

    const NavigationSetFields = (headData, setItemCode, setFormData) => {
        if (!headData || !headData.selected_Record_data) return;

        const { Item_Code, System_Name_E, ...rest } = headData.selected_Record_data;

        // Set item code separately
        setItemCode(Item_Code);

        // Optional: assign to global (if needed)
        Item_Code = Item_Code;
        Item_Name = System_Name_E;

        // Set form data
        setFormData((prevData) => ({
            ...prevData,
            ...headData.selected_Record_data,
        }));
    };


    const handleNavigateRecord = async () => {
        setIsEditing(false);
        setIsEditMode(false);
        setAddOneButtonEnabled(true);
        setEditButtonEnabled(true);
        setDeleteButtonEnabled(true);
        setBackButtonEnabled(true);
        setSaveButtonEnabled(false);
        setCancelButtonEnabled(false);
        setCancelButtonClicked(true);
        try {
            const response = await axios.get(
                `${API_URL}/get-AwakAdvanceSelectedRecordByItemCode?Item_Code=${formData.Item_Code || itemCode}&Company_Code=${companyCode}&Year_Code=${YearCode}`
            );
            if (response.status === 200) {
                const data = response.data;

                newId = data.selected_Record_data.Id;
                Item_Code = data.selected_Record_data.Item_Code;
                Item_Name = data.selected_Record_data.System_Name_E;
                setFormData((prevData) => ({
                    ...prevData,
                    ...data.selected_Record_data,
                }));
                setFormData(data.selected_Record_data || {});
            } else {
                console.error(
                    "Failed to fetch last tender data:",
                    response.status,
                    response.statusText
                );
            }
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };



    //Handle Record DoubleCliked in Utility Page Show that record for Edit
    const handlerecordDoubleClicked = async () => {
        try {
            const response = await axios.get(
                `${API_URL}/get-AwakAdvanceSelectedRecordByItemCode`,
                {
                    params: {
                        Item_Code: selectedRecord.Item_Code,
                        Company_Code: companyCode,
                        Year_Code: YearCode
                    }
                }
            );

            // Axios auto-parses JSON, so response.data is already the parsed object
            const data = response.data;

            const firstItemwiseArray = data.selected_Record_data || [];
            const ItemCode = data.Item_Code;

            setItemCode(ItemCode);

            const formattedRows = firstItemwiseArray.map((row) => ({
                ...row,
                id: row.Id,
                rowaction: 'Normal',
                Eff_Date: formatToInputDate(row.Eff_Date),
                Market_Cess: parseFloat(formData.Market_Cess || row.Market_Cess || 0.00),
                // MarkaPerc: parseFloat(formData.Market_Cess || row.Market_Cess || 0.00),
            }));

            setItemwiseTableData(formattedRows);

            if (formattedRows.length > 0) {
                setFormData({
                    ...formattedRows[0],
                });
            }
        } catch (error) {
            console.error("❌ Error during API call:", error);
        }

        setIsEditMode(false);
        setAddOneButtonEnabled(true);
        setEditButtonEnabled(true);
        setDeleteButtonEnabled(true);
        setBackButtonEnabled(true);
        setSaveButtonEnabled(false);
        setCancelButtonEnabled(false);
        setUpdateButtonClicked(true);
        setIsEditing(false);
    };


    useEffect(() => {
        if (selectedRecord) {
            handlerecordDoubleClicked();
        } else {
            handleAddOne();
        }
    }, [selectedRecord]);



    const handleKeyDown = async (event) => {
        if (event.key === "Tab") {
            const changeNoValue = event.target.value;


            setItemwiseTableData([]);
            setFormData({});

            try {
                const response = await axios.get(
                    `${API_URL}/get-AwakAdvanceSelectedRecordByItemCode?Item_Code=${changeNoValue}&Company_Code=${companyCode}&Year_Code=${YearCode}`
                );

                if (response.status === 200) {
                    const data = response.data;

                    const lastItemwiseArray = data.selected_Record_data || [];


                    setItemCode(changeNoValue);

                    const formattedRows = lastItemwiseArray.map((row) => ({
                        ...row,
                        id: row.Id,
                        rowaction: 'Normal',
                        Eff_Date: formatToInputDate(row.Eff_Date),
                        Market_Cess: parseFloat(formData.Market_Cess || row.Market_Cess || 0.00),
                        // MarkaPerc: parseFloat(formData.Market_Cess || row.Market_Cess || 0.00),
                    }));

                    setItemwiseTableData(formattedRows);



                    if (formattedRows.length > 0) {
                        setItemwiseTableData(formattedRows);
                        setFormData({
                            ...formattedRows[0],
                        });
                    }
                } else {
                    console.error(
                        "Failed to fetch item-wise data:",
                        response.status,
                        response.statusText
                    );
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        }
    };



    const handleItemCode = (code, accoid, hsn, name, tableData) => {
        setItemCode(code);
        setItemName(name);
        setItemCodeAccoid(accoid);

        setFormData({
            ...formData,
            Item_Code: code,
            ic: accoid
        })

    };


    const handleAddRow = () => {
        setIsAddingRow(true);

        if (!itemCode || formData.Item_Code === null || String(itemCode).trim() === "") {
            Swal.fire({
                icon: "warning",
                title: "Missing Item Code",
                text: "Please select an Item Code before adding a row.",
                confirmButtonColor: "#d33",
            });
            return;
        }


        if (!itemwiseTableData || itemwiseTableData.length === 0) {
            const newFrontendId = 1;
            const today = new Date();
            const formattedDate = today.toISOString().split('T')[0];

            const newRow = {
                id: newFrontendId,
                Id: undefined,
                Item_Code: itemCode || formData.Item_Code,
                Eff_Date: formattedDate,
                Market_Cess: 0.00,
                MarkaPerc: 0.00,
                Dekrekh: 0.00,
                Hamali_on: "B",
                Hamali_rate: 0.00,
                HamaliSale_rate: 0.00,
                TolaiSale_rate: 0.00,
                Tolai_rate: 0.00,
                Tolad_on: "Q",
                Levi_rate: 0.00,
                Container: 0.00,
                rowaction: "add"
            };

            setItemwiseTableData([newRow]);
            return;
        }

        const lastRow = itemwiseTableData[itemwiseTableData.length - 1];

        const lastDate = lastRow?.Eff_Date ? new Date(lastRow.Eff_Date) : new Date();


        const nextDate = new Date(lastDate);
        nextDate.setDate(nextDate.getDate() + 1);
        const formattedDate = nextDate.toISOString().split('T')[0];


        const maxFrontendId = itemwiseTableData.reduce((max, row) => (
            row.id && row.id > max ? row.id : max
        ), 0);
        const newFrontendId = maxFrontendId + 1;


        const {
            Id,
            id,
            rowaction,
            ...cloneData
        } = lastRow;

        const newRow = {
            ...cloneData,
            id: newFrontendId,
            Id: undefined,
            Item_Code: itemCode,
            Eff_Date: formattedDate,
            Market_Cess: 0.00,
            MarkaPerc: 0.00,
            Dekrekh: 0.00,
            Hamali_on: "B",
            Hamali_rate: 0.00,
            HamaliSale_rate: 0.00,
            TolaiSale_rate: 0.00,
            Tolai_rate: 0.00,
            Tolad_on: "Q",
            Levi_rate: 0.00,
            Container: 0.00,
            rowaction: "add"
        };

        setItemwiseTableData((prev) => [...prev, newRow]);
    };








    const handleChangeInTable = (id, field, value) => {
        setItemwiseTableData(prev => {
            const updated = prev.map(row => {
                if (row.id === id) {
                    const updatedRow = { ...row, [field]: value };

                    if (updatedRow.Id && updatedRow.rowaction !== 'add') {
                        updatedRow.rowaction = 'update';
                    }

                    if (!updatedRow.Id && !updatedRow.rowaction) {
                        updatedRow.rowaction = 'add';
                    }

                    return updatedRow;
                }
                return row;
            });

            return updated;
        });
    };




    const handleDateTabValidation = async (event, rowId, fieldName) => {
        if (event.key === "Tab" && fieldName && fieldName.toLowerCase().includes("date")) {
            const value = event.target.value;
            if (!value) return;

            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const typedDate = new Date(value);
            typedDate.setHours(0, 0, 0, 0);

            if (typedDate < today) {
                event.preventDefault();
                Swal.fire({
                    icon: "warning",
                    title: "Invalid Date",
                    text: "You cannot enter a past date.",
                    confirmButtonColor: "#d33",
                });

                setItemwiseTableData(prev =>
                    prev.map(row =>
                        row.id === rowId
                            ? { ...row, [fieldName]: today.toISOString().split("T")[0] }
                            : row
                    )
                );
                return;
            }

            try {
                const response = await axios.get(`${API_URL}/get_match_status_forDate`, {
                    params: {
                        Eff_Date: value,
                        Company_Code: companyCode,
                        Year_Code: YearCode,
                        Item_Code: Item_Code || formData.Item_Code
                    }
                });

                const matchStatus = response.data?.match_status;

                if (matchStatus === 1) {
                    Swal.fire({
                        icon: "warning",
                        title: "Date Already Exists",
                        text: `Date ${value} already exists in database.`,
                        confirmButtonColor: "#d33",
                    });

                    setItemwiseTableData(prev =>
                        prev.map(row =>
                            row.id === rowId
                                ? { ...row, [fieldName]: "" }
                                : row
                        )
                    );
                    event.preventDefault();
                }

            } catch (error) {
                console.error("Error checking match status:", error);
            }
        }
    };






    const handleRemoveRow = (idToRemove) => {
        setItemwiseTableData((prev) =>
            prev.filter((row) => {
                // Remove completely if it's a new (unsaved) row
                if (!row.Id || row.rowaction === "add") {
                    return row.id !== idToRemove;
                }

                // Otherwise, mark for deletion
                return row.id !== idToRemove
                    ? true
                    : { ...row, rowaction: "delete" };
            })
        );
    };


    // if (canView === false) return <PageNotFound />;

    const handlePerPageChange = (event) => {
        setPerPage(event.target.value);
        setCurrentPage(1);
    };

    const handleSearchTermChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const pageCount = Math.ceil(itemwiseTableData.length / perPage);
    const paginatedPosts = itemwiseTableData.slice((currentPage - 1) * perPage, currentPage * perPage);


    return (
        <>
            <UserAuditInfo
                createdBy={formData.Created_By}
                modifiedBy={formData.Modified_By}
                title={"Item Wise Cess"}
            />
            <ToastContainer autoClose={500} />
            <br></br>
            <ActionButtonGroup
                handleAddOne={handleAddOne}
                addOneButtonEnabled={addOneButtonEnabled}
                handleSaveOrUpdate={handleSaveOrUpdate}
                saveButtonEnabled={saveButtonEnabled}
                isEditMode={isEditMode}
                handleEdit={handleEdit}
                editButtonEnabled={editButtonEnabled}
                // handleDelete={handleDelete}
                deleteButtonEnabled={deleteButtonEnabled}
                handleCancel={handleCancel}
                cancelButtonEnabled={cancelButtonEnabled}
                handleBack={handleBack}
                backButtonEnabled={backButtonEnabled}
                isDeleted={formData.IsDeleted === 0}
                permissions={permissions}
            />

            <div >
                <br></br>
                <Paper elevation={3} sx={{ p: 1, borderRadius: 2, mb: 4 }}>
                    <Box component="form" noValidate autoComplete="off">
                        <Grid container spacing={1}>
                            {/* Change No */}
                            <Grid item xs={12} md={2.5}>
                                <Grid container alignItems="center" spacing={1}>
                                    <Grid item xs={4}>
                                        <label htmlFor="changeNo" className="form-label">Change No:</label>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <input
                                            type="text"
                                            id="changeNo"
                                            name="changeNo"
                                            autoComplete="off"
                                            onKeyDown={handleKeyDown}
                                            disabled={!addOneButtonEnabled}
                                            className="form-input"
                                            style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={2.5}>
                                <Grid container alignItems="center">
                                    <Grid item xs={4}>
                                        <label htmlFor="Item_Code" className="form-label">Item Code:</label>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <SystemHelpMaster
                                            onAcCodeClick={handleItemCode}
                                            CategoryName={item_Name}
                                            CategoryCode={itemCode}
                                            // tableData={handleTableDataFromApi}
                                            SystemType="I"
                                            name="Item_Code"
                                            firstInputRef={firstInputRef}
                                            disabledField={isEditMode || addOneButtonEnabled}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                        </Grid>
                    </Box>

                </Paper>


                <Box sx={{ mb: 2, display: 'flex', gap: 2 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleAddRow}
                        disabled={!isEditMode && addOneButtonEnabled}
                        tableData={handleTableDataFromApi}
                        ref={addButtonRef}
                        component="button"
                    >
                        ADD
                    </Button>
                </Box>
                {/* Enhanced Tables */}
                <Grid container spacing={3}>
                    {/* Mill Table */}
                    <Grid item xs={12} md={12}>
                        <TableContainer component={Paper} sx={{ borderRadius: 2, mb: 4 }}>
                            <Table size="small" sx={{
                                width: '100%',
                            }}>
                                <TableHead>
                                    <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                        {/* <TableCell sx={{ fontWeight: 'bold' }}>System Code</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>System Name</TableCell> */}
                                        <TableCell sx={{ fontWeight: 'bold' }}>Eff Date</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Market Cess</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Dekrekh</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Hamali On</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Hamali Rate</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Hamali Sale Rate</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Tolad ON</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Tolai Rate</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Tolai Sale Rate</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Levi Rate</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Container</TableCell>
                                        {/* Add more columns as needed */}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {paginatedPosts.map((row, index) => (
                                        <TableRow key={row.id}>
                                            {/* <TableCell>{row?.System_Code}</TableCell>
                                            <TableCell>{row?.System_Name_E}</TableCell> */}
                                            <TableCell>
                                                <TextField
                                                    type="date"
                                                    size="small"
                                                    value={row?.Eff_Date || formData.Eff_Date}
                                                    onChange={(e) => handleChangeInTable(row.id, "Eff_Date", e.target.value)}
                                                    onKeyDown={(e) => handleDateTabValidation(e, row.id, "Eff_Date")}
                                                    disabled={row?.rowaction !== 'add' || !isEditing && addOneButtonEnabled}
                                                    inputProps={{
                                                        min: new Date().toISOString().split("T")[0], // Disable past dates
                                                    }}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <TextField
                                                    type="number"
                                                    size="small"
                                                    value={row?.Market_Cess || 0.00}
                                                    onChange={(e) => handleChangeInTable(row.id, "Market_Cess", e.target.value)}
                                                    disabled={!isEditing && addOneButtonEnabled}

                                                />
                                            </TableCell>
                                            <TableCell>
                                                <TextField
                                                    type="number"
                                                    size="small"
                                                    value={row?.Dekrekh || 0}
                                                    onChange={(e) => handleChangeInTable(row.id, "Dekrekh", e.target.value)}
                                                    disabled={!isEditing && addOneButtonEnabled}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <Select
                                                    size="small"
                                                    value={row?.Hamali_on || "B"}
                                                    onChange={(e) => handleChangeInTable(row.id, "Hamali_on", e.target.value)}
                                                    disabled={!isEditing && addOneButtonEnabled}
                                                    fullWidth
                                                >
                                                    <MenuItem value="B">Per Bag</MenuItem>
                                                </Select>
                                            </TableCell>
                                            <TableCell>
                                                <TextField
                                                    type="number"
                                                    size="small"
                                                    value={row?.Hamali_rate || 0}
                                                    onChange={(e) => handleChangeInTable(row.id, "Hamali_rate", e.target.value)}
                                                    disabled={!isEditing && addOneButtonEnabled}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <TextField
                                                    type="number"
                                                    size="small"
                                                    value={row?.HamaliSale_rate || 0}
                                                    onChange={(e) => handleChangeInTable(row.id, "HamaliSale_rate", e.target.value)}
                                                    disabled={!isEditing && addOneButtonEnabled}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <Select
                                                    size="small"
                                                    value={row?.Tolad_on || "Q"}
                                                    onChange={(e) => handleChangeInTable(row.id, "Tolad_on", e.target.value)}
                                                    disabled={!isEditing && addOneButtonEnabled}
                                                    fullWidth
                                                >
                                                    <MenuItem value="Q">Quintal</MenuItem>
                                                    <MenuItem value="U">Quantity</MenuItem>
                                                </Select>
                                            </TableCell>
                                            <TableCell>
                                                <TextField
                                                    type="number"
                                                    size="small"
                                                    value={row?.Tolai_rate || 0}
                                                    onChange={(e) => handleChangeInTable(row.id, "Tolai_rate", e.target.value)}
                                                    disabled={!isEditing && addOneButtonEnabled}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <TextField
                                                    type="number"
                                                    size="small"
                                                    value={row?.TolaiSale_rate || 0}
                                                    onChange={(e) => handleChangeInTable(row.id, "TolaiSale_rate", e.target.value)}
                                                    disabled={!isEditing && addOneButtonEnabled}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <TextField
                                                    type="number"
                                                    size="small"
                                                    value={row?.Levi_rate || 0}
                                                    onChange={(e) => handleChangeInTable(row.id, "Levi_rate", e.target.value)}
                                                    disabled={!isEditing && addOneButtonEnabled}

                                                />
                                            </TableCell>
                                            <TableCell>
                                                <TextField
                                                    type="number"
                                                    size="small"
                                                    value={row?.Container || 0}
                                                    onChange={(e) => handleChangeInTable(row.id, "Container", e.target.value)}
                                                    disabled={!isEditing && addOneButtonEnabled}
                                                    onKeyDown={(e) => {
                                                        if (
                                                            e.key === "Tab" &&
                                                            !e.shiftKey &&
                                                            index === paginatedPosts.length - 1
                                                        ) {
                                                            e.preventDefault();
                                                            addButtonRef.current?.focus();
                                                        }
                                                    }}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <IconButton
                                                    size="small"
                                                    color="error"
                                                    onClick={() => handleRemoveRow(row.id)}
                                                    disabled={row?.rowaction !== 'add' || !isEditing && addOneButtonEnabled}
                                                    onKeyDown={(e) => {
                                                        if (
                                                            e.key === "Tab" &&
                                                            !e.shiftKey &&
                                                            index === paginatedPosts.length - 1
                                                        ) {
                                                            e.preventDefault();
                                                            addButtonRef.current?.focus();
                                                        }
                                                    }}
                                                >
                                                    ✕
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Grid item xs={12} mt={3} mb={10}>
                            <Pagination
                                pageCount={pageCount}
                                currentPage={currentPage}
                                onPageChange={handlePageChange}
                            />
                        </Grid>

                    </Grid>
                </Grid>
            </div>
        </>
    );
};

export default ItemWiseCess;




